// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.X0ylLWUoyLE_jgJCZoF7{align-items:center;gap:2px;display:flex}.nOg7RgMbbQ3FkKuUr4CY{background:var(--content-neutral-primary);opacity:0;border-radius:50%;width:3px;height:3px;animation:1s infinite R1dWnRCViUs8Hfsdrq1Z}.nOg7RgMbbQ3FkKuUr4CY:first-child{animation-delay:0s}.nOg7RgMbbQ3FkKuUr4CY:nth-child(2){animation-delay:.2s}.nOg7RgMbbQ3FkKuUr4CY:nth-child(3){animation-delay:.4s}@keyframes R1dWnRCViUs8Hfsdrq1Z{0%{opacity:.2}50%{opacity:1}to{opacity:.2}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"typing": `X0ylLWUoyLE_jgJCZoF7`,
	"typing__dot": `nOg7RgMbbQ3FkKuUr4CY`,
	"typingDot": `nOg7RgMbbQ3FkKuUr4CY`,
	"loadingFade": `R1dWnRCViUs8Hfsdrq1Z`
};
export default ___CSS_LOADER_EXPORT___;
